import { gx } from "@/components/gtax/base";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { DAILY_RANGE, REPORT, usd } from "./data";

const up = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 1, delay: d, ease: [0.2, 0.7, 0.2, 1] } });

const STATS = [
  { k: usd(REPORT.net), v: "Net realised profit · MT5 record, Apr–Oct 2026", id: "record" },
  { k: `${DAILY_RANGE.low}% – ${DAILY_RANGE.high}%`, v: "Historical daily range of the strategy (gross)", id: "range" },
  { k: "5,394", v: "XAU/USD deals executed, A-book", id: "deals" },
  { k: "1.77", v: "Profit factor, gross profit ÷ gross loss", id: "pf" },
];

export const GtaxHero = () => (
  <section className="relative pt-44 pb-24 overflow-hidden" data-testid="gtax-hero">
    <div className="gx-wrap relative grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-7">
        <motion.p {...up(0.1)} className="gx-eyebrow mb-8">Gold Trading Association · a product of DFI Holdings</motion.p>
        <motion.h1 {...up(0.25)} className="gx-serif text-[2.5rem] sm:text-6xl lg:text-7xl leading-[1.04] break-words">
          Gold, managed with <span className="gx-gold italic">institutional discipline.</span>
        </motion.h1>
        <motion.p {...up(0.4)} className="mt-8 max-w-xl text-lg text-[color:var(--mute)] leading-relaxed">
          A discretionary XAU/USD mandate for a private circle of members. Allocations are settled in USDT into the GTA X
          Consolidated Treasury, deployed as a single managed mandate, and distributed strictly from realised trading profit.
        </motion.p>
        <motion.div {...up(0.55)} className="mt-12 flex flex-wrap gap-4">
          <Link to={gx("/access")} className="gx-btn" data-testid="gtax-hero-cta">Request access</Link>
          <Link to={gx("/report")} className="gx-ghost" data-testid="gtax-hero-performance">View the track record</Link>
        </motion.div>
      </div>
      <motion.div {...up(0.35)} className="lg:col-span-5 flex justify-center" data-testid="gtax-hero-emblem">
        <img src="/gtax/logo.png" alt="GTA X emblem" className="gx-emblem w-[300px] sm:w-[380px] lg:w-[460px] object-contain" />
      </motion.div>
    </div>
    <div className="gx-wrap relative">
      <motion.div {...up(0.75)} className="mt-20 grid grid-cols-2 md:grid-cols-4 gx-line">
        {STATS.map((s) => (
          <div key={s.id} className="pt-8 pr-8" data-testid={`gtax-stat-${s.id}`}>
            <div className="gx-serif text-3xl md:text-4xl gx-gold">{s.k}</div>
            <div className="mt-2 text-sm text-[color:var(--mute)]">{s.v}</div>
          </div>
        ))}
      </motion.div>
      <p className="mt-8 text-xs text-[color:var(--mute)]">Past performance is not a reliable indicator of future results. No return is guaranteed.</p>
    </div>
  </section>
);
